import apiClient from "../../helpers/apiClient";
import { isEmptyObj } from "../../helpers/validator";
import { createLoadingSelector } from "./Loading";

export const FETCH_TRANSACTIONS = "FETCH_TRANSACTIONS";
export const FETCH_TRANSACTIONS_REQUEST = "FETCH_TRANSACTIONS_REQUEST";
export const FETCH_TRANSACTIONS_SUCCESS = "FETCH_TRANSACTIONS_SUCCESS";
export const FETCH_TRANSACTIONS_FAILURE = "FETCH_TRANSACTIONS_FAILURE";

export const FETCH_TRANSACTION_DETAILS = "FETCH_TRANSACTION_DETAILS";
export const FETCH_TRANSACTION_DETAILS_REQUEST =
  "FETCH_TRANSACTION_DETAILS_REQUEST";
export const FETCH_TRANSACTION_DETAILS_SUCCESS =
  "FETCH_TRANSACTION_DETAILS_SUCCESS";
export const FETCH_TRANSACTION_DETAILS_FAILURE =
  "FETCH_TRANSACTION_DETAILS_FAILURE";

export const GET_TRANSACTION_LIST = "GET_TRANSACTION_LIST";
export const GET_TRANSACTION_LIST_REQUEST = "GET_TRANSACTION_LIST_REQUEST";
export const GET_TRANSACTION_LIST_SUCCESS = "GET_TRANSACTION_LIST_SUCCESS";
export const GET_TRANSACTION_LIST_FAILURE = "GET_TRANSACTION_LIST_FAILURE";

export const INVALIDATE_DID_LOADED = "INVALIDATE_DID_LOADED";

const initialState = {
  data: {},
  didLoaded: false,
  errorMessage: ""
};

export const invalidateDidLoaded = () => dispatch => {
  dispatch({ type: INVALIDATE_DID_LOADED });
  return Promise.resolve();
};

export const loadingTransactionsSelector = createLoadingSelector([
  FETCH_TRANSACTIONS
]);
// export const fetchTransactions = cardNo => dispatch => {
//   return dispatch({
//     types: [
//       FETCH_TRANSACTIONS_REQUEST,
//       FETCH_TRANSACTIONS_SUCCESS,
//       FETCH_TRANSACTIONS_FAILURE
//     ],
//     callAPI: config =>
//       apiClient.post(
//         `Card/GetTransactionHistory?CardNo=${cardNo}`,
//         cardNo,
//         config
//       ),
//     payload: { cardNo }
//   }).then(res => {
//     console.log("transaction:", res);
//   });
// };
export const fetchTransactions = pageNo => dispatch => {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  let yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  today = dd + "/" + mm + "/" + yyyy;

  let data = {
    fromDate: "01/09/2019",
    toDate: today,
    pageSize: 6,
    pageNo: pageNo
  };

  // console.log("date11:", data);

  return dispatch({
    types: [
      FETCH_TRANSACTIONS_REQUEST,
      FETCH_TRANSACTIONS_SUCCESS,
      FETCH_TRANSACTIONS_FAILURE
    ],
    callAPI: config =>
      apiClient.post(`Membership/GetTransactionList`, data, config),
    payload: { data }
  }).then(res => {
    // console.log("transaction11:", res.response.data.result);
  });
};

export const loadingTransactionDetailsSelector = createLoadingSelector([
  FETCH_TRANSACTION_DETAILS
]);
export const fetchTransactionDetails = (receiptNo, autoID) => dispatch => {
  return dispatch({
    types: [
      FETCH_TRANSACTION_DETAILS_REQUEST,
      FETCH_TRANSACTION_DETAILS_SUCCESS,
      FETCH_TRANSACTION_DETAILS_FAILURE
    ],
    shouldCallAPI: state =>
      !loadingTransactionDetailsSelector(state) &&
      (isEmptyObj(state.transaction.data) ||
        !state.transaction.data[autoID] ||
        !state.transaction.data[autoID].transactionDetailsList ||
        state.transaction.data[autoID].transactionDetailsList.length <= 0),
    callAPI: config =>
      apiClient.get(
        `api/transaction/GetTransactionDetails/${receiptNo}/${autoID}`,
        config
      ),
    payload: { receiptNo }
  });
};

export default function reducer(state = initialState, action) {
  const { payload, errorMessage, response } = action;
  // console.log("transaction:", action);
  switch (action.type) {
    case FETCH_TRANSACTIONS_REQUEST:
    case FETCH_TRANSACTION_DETAILS_REQUEST:
      return {
        ...state,
        errorMessage: "",
        successMessage: ""
      };
    case FETCH_TRANSACTIONS_FAILURE:
    case FETCH_TRANSACTION_DETAILS_FAILURE:
      return {
        ...state,
        errorMessage: errorMessage
      };
    case FETCH_TRANSACTIONS_SUCCESS:
      // console.log("transaction:", response.data.result);
      return {
        ...state,
        data: response.data.result,
        didLoaded: true
      };
    case FETCH_TRANSACTION_DETAILS_SUCCESS:
      const currentTxnDetails = state.data[payload.autoID]
        ? state.data[payload.autoID]
        : {};
      return {
        ...state,
        data: {
          ...state.data,
          [payload.autoID]: {
            ...currentTxnDetails,
            ...payload
          }
        }
      };
    case INVALIDATE_DID_LOADED:
      return { ...state, didLoaded: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/Transaction.js